import { Box } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

//Transitions need to live outside the fuction to operate
export const DRAWER_WIDTH = 340;

const openedMixin = (theme) => ({
	width: DRAWER_WIDTH,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.complex,
	}),
	overflowX: 'hidden',
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.shortest,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(8)} + 1px)`,
});

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
	({ theme }) => ({
		width: DRAWER_WIDTH,
		variants: [{
			props: ({ open }) => open,
			style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme), },
		},
		{
			props: ({ open }) => !open,
			style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme), },
		},],
	}),
);

const openedSiblingMixin = (theme) => ({
	transition: theme.transitions.create('margin', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.shortest,
	}),
	overflowX: 'hidden',
	marginRight: `calc(${theme.spacing(8)} + 1px)`,
});

const closedSiblingMixin = (theme) => ({
	marginRight: DRAWER_WIDTH,
	transition: theme.transitions.create('margin', {
		easing: theme.transitions.easing.easeOut,
		duration: theme.transitions.duration.complex,
	}),
	overflowX: 'hidden',
});

export const DrawerSibling = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(
	({ theme }) => ({
		marginRight: 0,
		variants: [{
			props: ({ open }) => open,
			style: { ...closedSiblingMixin(theme), },
		},
		{
			props: ({ open }) => !open,
			style: { ...openedSiblingMixin(theme), },
		},],
	}),
);